export class IncompatiblePreparationAccountError extends Error {}
